import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { useKYC } from 'Hooks/Aggregators/useKYC';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { KYCOrganismLayout } from './layout';

export const KYCOrganismContainer = ({ resource, linkTokenResource, onKYCFinished }) => {
  const [inKYC, setInKYC] = useState(false);
  const onExit = useCallback(() => setInKYC(false), []);
  const { startKYC, initializationError, isInitialized } = useKYC({
    resource: linkTokenResource,
    onKYCFinished,
    onExit,
  });

  return (
    <FullScreenDataContainer
      loading={!isInitialized}
      loadingError={initializationError}
      component={MetaResourceRenderer}
      componentProps={{
        LayoutProps: { startKYC, inKYC, setInKYC },
        layout: KYCOrganismLayout,
        resource,
      }}
    />
  );
};

KYCOrganismContainer.defaultProps = {
};

KYCOrganismContainer.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  linkTokenResource: PropTypes.instanceOf(fr.Resource).isRequired,
  onKYCFinished: PropTypes.func.isRequired,
};
